export const aboutCardSkeletonStyles = {
  wrapper: {
    display: {
      laptop: "flex",
    },
    alignItems: "center",
    justifyContent: "center",
    margin: {
      tablet: "0 2.5rem 7.5rem",
      laptop: "0 auto 7.5rem",
    },
    width: {
      laptop: "95vw",
      desktop: "unset",
    },
    maxWidth: {
      laptop: "69.438rem",
    },
    borderRadius: {
      tablet: "0.938rem",
    },
    overflow: {
      tablet: "hidden",
    },
  },
  image: {
    minWidth: {
      laptop: "29.75rem",
    },
    height: {
      mobile: "20rem",
      laptop: "40rem",
    },
  },
  textContainer: {
    padding: {
      tablet: "4rem 3.62rem",
      laptop: "0",
    },
    mb: {
      mobile: "5rem",
      tablet: "unset",
    },
    width: {
      laptop: "50vw",
    },
    mx: {
      laptop: "1.875rem",
      desktop: "3.125rem",
    },
    alignItems: {
      mobile: "center",
      laptop: "unset",
    },
  },
  title: {
    height: "2rem",
    my: {
      mobile: "1.5rem",
    },
    width: {
      mobile: "70%",
      laptop: "50%",
    },
  },
  text: {
    mb: "1.25rem",
    width: {
      mobile: "80vw",
      laptop: "90%",
    },
    height: "1.25rem",
  },
};
